export const ADDEDFILTER = "filter/addedfilter";
